import { Box } from '@usap/uicomponents';
import styled from 'styled-components';

const whiteColor = (props) => props.theme.global.colors['white'];
const colorDarkSecondary = (props) =>
  props.theme.global.colors['darkSecondary'];

export const Container = styled(Box)`
  border-radius: 4px;
  background: ${whiteColor};
  padding: 16px;
  border: 1px solid #d4d4d6;
  margin-bottom: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const BetaText = styled.p`
  font-size: 12px;
  color: #5E5E65;
  line-height: 16px;
  text-align: center;
  margin: 12px 0 0;
`;

export const Icon = styled.div`
  display: flex;
  flex-shrink: 0;

  @media (max-width: 600px) {
    max-width: 48px;
  }
`;

export const Heading = styled.h2`
  font-size: 20px;
  font-weight: 500;
  line-height: 150%;
  color: ${colorDarkSecondary};
  margin: 0;
  width: 75%;

  @media (max-width: 600px) {
    width: unset;
    font-size: 18px;
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 165%;
  color: ${colorDarkSecondary};
  margin-bottom: 8px;
`;

export const TrackAnchor = styled.a`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  background: #ffcd05;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: ${colorDarkSecondary};
  cursor: pointer;

  :hover {
    background: rgb(255 220 80);
  }
`;

export const TrackButton = styled.button`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  background: #ffcd05;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: ${colorDarkSecondary};
  cursor: pointer;
  outline: none;

  :hover {
    background: rgb(255 220 80);
  }
`;
